const DataDic: any = {
  award_authoriry_organization_options: [
    '重庆市人民小学校',
    '重庆市教委',
    '重庆市渝中区教委',
    '重庆市渝中区教育科研委员会',
  ],
  genderList: [
    { value: 0, label: '女' },
    { value: 1, label: '男' }
  ],
  zaibianList: [
    { value: 0, label: '不在编' },
    { value: 1, label: '在编' }
  ],
};

export default DataDic;


// WEBPACK FOOTER //
// ./src/dataModel/DataDic.ts